import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=70b14f68&scoped=true"
import script from "./dropdown-item.vue?vue&type=script&lang=js"
export * from "./dropdown-item.vue?vue&type=script&lang=js"
import style0 from "./dropdown-item.vue?vue&type=style&index=0&id=70b14f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b14f68",
  null
  
)

export default component.exports